import React, { Component } from 'react';
import { Modal, Calendar } from "antd";
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class ModalMultiCalender extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isPanelChange: false,
      selectedDates: [] //props.defaultValues
    };

  }

  onPanelChange = (value, mode) => {
  };

  onSelect = (value) => {

    let { selectedDates } = this.state;

    let formatedValue = moment(value).format(dateFormat);

    if (selectedDates.some(e => e === formatedValue)) {
      selectedDates = selectedDates.filter(e => e !== formatedValue)
    } else {
      selectedDates.push(formatedValue);
    }

    selectedDates = selectedDates.sort((a, b) => new Date(a) - new Date(b));

    this.setState({ selectedDates })

    // let { onSelect } = this.props;
    // onSelect(selectedDates);

  };

  handleOk = () => {

    const { onSelect } = this.props;
    onSelect(this.state.selectedDates)


  };

  onFullRender = (date) => {

    let { selectedDates } = this.state;

    if (selectedDates.some(e => moment(e).format(dateFormat) === moment(date).format(dateFormat))) {
      return <div className="ant-picker-cell-inner ant-picker-calendar-date  ant-picker-cell-selected">
        <div className="ant-picker-calendar-date-value">{date.format("DD")}</div>
        <div className="ant-picker-calendar-date-content"></div>
      </div>
    }

    return <div className="ant-picker-cell-inner ant-picker-calendar-date">
      <div className="ant-picker-calendar-date-value">{date.format("DD")}</div>
      <div className="ant-picker-calendar-date-content"></div>
    </div>;

  }

  render() {

    const { isModalOpen, handleCancel, createOptions } = this.props;

    return (
      <Modal title="Takvim" centered open={isModalOpen} onOk={this.handleOk} onCancel={handleCancel} maskClosable={false} destroyOnClose={true}>
        <Calendar
          fullscreen={false}
          onSelect={this.onSelect}
          onPanelChange={this.onPanelChange}
          mode={"month"}
          dateFullCellRender={this.onFullRender}
          className='multicalendar'
          disabledDate={d => !d || d.isBefore(createOptions.minDepartureDate)}

        />
      </Modal>
    )
  }
}
export default ModalMultiCalender;


// WEBPACK FOOTER //
// ./src/components/App/components/ModalMultiCalender.js